export class DistributorType {

  constructor() { }

  type: number;

  typeEnum = {
    PARTICIPANT: 1,
    PARTICIPANT2: 2,
    PARTICIPANT3: 3,
    PARTICIPANTSAI1: 3,
    PARTICIPANTSAI2: 3,
    WINNER: 4,
    LOGIST: 5
  };
}



// WEBPACK FOOTER //
// ./src/app/modules/home/models/distributor-type.ts